// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2kyrN","selected":"Chip_selected__1kd9k"};